import { withForm } from "~/components/form/app-form";
import { Card, CardContent, CardHeader, CardTitle } from "~/components/ui/card";

import { offerFormOptions } from "../offer-form-options";

export const FinalCtaSection = withForm({
  ...offerFormOptions,
  render: function Render({ form }) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Final call to action</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <form.AppField name="bottomCtaHeadline">
            {(field) => <field.TextField label="Bottom CTA Headline" />}
          </form.AppField>

          <form.AppField name="bottomCtaText">
            {(field) => (
              <field.TextareaField label="Bottom CTA Text" maxLength={500} />
            )}
          </form.AppField>
        </CardContent>
      </Card>
    );
  },
});
